import { eventNames, useCoreEvents } from '@carvana/core-events';
import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import Modal from '@/common/Modal';
import { useGetUser, useIsLoggedIn } from '~/context/common/UserContext';
import ModalContext from '~/context/sem/ModalContext';
import { useShowFinance } from '~/context/sem/StaticContext';
import UserProfileIcon from '~/icons/UserProfile';
import { MenuItem, MenuItemAnchor, MenuItems } from './HeaderMenuModal.styles';

export default function HeaderMenuModal() {
  const { isHeaderMenuModalOpen, setHeaderMenuModalOpen } =
    useContext(ModalContext);
  const { emit } = useCoreEvents();
  const { given_name: givenName } = useGetUser();
  const isLoggedIn = useIsLoggedIn();
  const showFinance = useShowFinance();

  return (
    <Modal
      headerText="Menu"
      open={isHeaderMenuModalOpen}
      onToggle={() => {
        setHeaderMenuModalOpen(false);
      }}
    >
      <MenuItems>
        {isLoggedIn ? (
          <MenuItemAnchor
            href="/account-ui/personal-details"
            className="bg-white"
            data-analytics-id="Header Menu - Personal Details"
          >
            <UserProfileIcon />
            <span className="normal-case tl-body-m">{givenName}</span>
          </MenuItemAnchor>
        ) : (
          <Clickable
            element={MenuItem}
            className="anchor bg-white"
            onClick={() => {
              emit(eventNames.accountModal.open);
              setHeaderMenuModalOpen(false);
            }}
            data-analytics-id="Header Menu - Sign In"
          >
            Sign In
          </Clickable>
        )}

        <MenuItemAnchor
          href="/cars"
          data-analytics-id="Header Menu - Search Cars"
        >
          Search Cars
        </MenuItemAnchor>

        <MenuItemAnchor
          href="/sell-my-car"
          data-analytics-id="Header Menu - Sell/Trade"
        >
          Sell/Trade
        </MenuItemAnchor>

        {showFinance && (
          <MenuItemAnchor
            href="/financing-prequalification"
            data-analytics-id="Header Menu - Financing"
          >
            Financing
          </MenuItemAnchor>
        )}
      </MenuItems>
    </Modal>
  );
}
